import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ErrorPageImg from '../../static/img/error-something-went-wrong.svg';

import './ErrorPage.scss';

class ErrorPage extends Component {
  render() {
    return (
      <div className="error-page slds-grid slds-wrap slds-grid--align-center">
        <div className="slds-size--1-of-1 error-image">
          <img
            src={ErrorPageImg}
            alt="Data Unavailable: Something went wrong."
          />
        </div>
        <div className="slds-size--1-of-1">
          <h1 className="slds-page-header__title">
            Hmm ... Something Went Wrong
          </h1>
        </div>
      </div>
    );
  }
}

ErrorPage.propTypes = {
  params: PropTypes.object
};

export default ErrorPage;
